/** 검색 대상 절 — 제목·장 이름과, 절 안 글 전체(단계 제목·설명·참고) */
export interface ManualSearchEntry {
  id: string;
  title: string;
  chapter: string;
  text: string;
}

export interface ManualSearchHit {
  entry: ManualSearchEntry;
  /** 맞은 자리 앞뒤 글(본문에 없으면 빈 글) */
  snippet: string;
}

const MAX_HITS = 8;
const SNIPPET_BEFORE = 18;
const SNIPPET_AFTER = 40;
const TITLE_SCORE = 2;
const TEXT_SCORE = 1;

/**
 * 기능 이름으로 절 찾기(service-manual 「매뉴얼 검색」): 제목에 있으면 2점, 본문에 있으면 1점, 점수 높은 순(같으면 문서 순) 8개.
 * 대소문자는 가리지 않고, 빈 칸뿐인 입력은 찾지 않는다.
 */
export function searchManual(
  entries: readonly ManualSearchEntry[],
  query: string
): ManualSearchHit[] {
  const keyword = query.trim().toLowerCase();
  if (!keyword) return [];
  return entries
    .map((entry) => {
      const text = entry.text.toLowerCase();
      const score =
        (entry.title.toLowerCase().includes(keyword) ? TITLE_SCORE : 0) +
        (text.includes(keyword) ? TEXT_SCORE : 0);
      const at = text.indexOf(keyword);
      const snippet =
        at >= 0
          ? entry.text.slice(
              Math.max(0, at - SNIPPET_BEFORE),
              at + SNIPPET_AFTER
            )
          : "";
      return { entry, snippet, score };
    })
    .filter((hit) => hit.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, MAX_HITS)
    .map(({ entry, snippet }) => ({ entry, snippet }));
}
